import { QueryClient } from '@tanstack/react-query';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000,
      gcTime: 30 * 60 * 1000,
      retry: (failureCount, error) => {
        if (error?.code === 'permission-denied' || error?.code === 'not-found') return false;
        if (error?.code === 'unavailable' && failureCount >= 2) return false;
        return failureCount < 3;
      },
      refetchOnWindowFocus: false,
      refetchOnReconnect: 'always',
      retryDelay: attemptIndex => {
        const baseDelay = Math.min(1000 * 2 ** attemptIndex, 30000);
        const jitter = Math.random() * 1000;
        return baseDelay + jitter;
      },
      networkMode: 'offlineFirst',
      structuralSharing: true,
      throwOnError: false,
    },
    mutations: {
      retry: (failureCount, error) => {
        if (error?.code === 'invalid-argument' || error?.status === 400 || error?.status === 422)
          return false;
        if (error?.code === 'permission-denied' || error?.status === 403) return false;
        return failureCount < 2;
      },
      retryDelay: 1500,
      networkMode: 'online',
    },
  },
});
